import React, { useContext, useState } from 'react';
import { isArray, flatten, map, cloneDeep } from 'lodash';
import DropdownButton from '../../../../common/dropdownButton';
import { FocusBaseContext, MarkupContext } from '../../contexts';
import SideBySideModal from '../conceptFocusReportModal/appWrapper';

const Reports = () => {
  const [ sideBySideConcepts, setSideBySideConcepts ] = useState(null);
  const {
    selectedConceptId, conceptById, reportPath, currentSummary,
    currentKinds, openReport, markupType
  } = useContext(FocusBaseContext);

  const { threshold, resolution } = useContext(MarkupContext);

  const markupParams = (reportName, concept_id = null, settingsForConceptId = null) => {
    const data = { report: reportName };

    const conceptAsArray = isArray(concept_id) ? flatten(concept_id) : [ concept_id ];
    data.concept_ids = concept_id ? conceptAsArray : map(currentSummary.report.concepts, (el) => el.id);
    if (settingsForConceptId) {
      data.existing_settings = currentSummary.settings[settingsForConceptId];
    }

    if ((currentSummary.filter || []).length > 0) {
      data.filter = currentSummary.filter;
    }
    if (markupType !== 'area_and_text') {
      data.markup = markupType;
    }

    if (!(currentKinds.positive && currentKinds.negative && currentKinds.confusing)) {
      const reactions = [];
      if (currentKinds.positive) {
        reactions.push('positive');
      }
      if (currentKinds.negative) {
        reactions.push('negative');
      }
      if (currentKinds.confusing) {
        reactions.push('confusing');
      }
      if (reactions.length > 0) {
        data.reactions = reactions;
      }
    }
    return data;
  };

  const pptxHeatmapParams = (concept_id = null, settingsForConceptId = null) => {
    const params = markupParams('pptxHeatmap', concept_id, settingsForConceptId);
    params.threshold = threshold;
    params.resolution = resolution;
    return params;
  };

  const pptxMarkupParams = (concept_id = null, settingsForConceptId = null) => (
    markupParams('pptxMarkup', concept_id, settingsForConceptId)
  );

  const xlsxMarkupParams = (concept_id = null, settingsForConceptId = null) => (
    markupParams('xlsxMarkup', concept_id, settingsForConceptId)
  );

  const handleOpenSideBySideSettings = (event) => {
    event.preventDefault();
    setSideBySideConcepts(cloneDeep(currentSummary.report.concepts));
  };

  const handleCloseSideBySideSettings = (event) => {
    event.preventDefault();
    setSideBySideConcepts(null);
  };

  const runSideBySideExport = (event, concept_ids) => {
    const params = markupParams('pptxHeatmapPosNeg', concept_ids);
    params.threshold = threshold;
    params.resolution = resolution;
    openReport(event, params, reportPath);
    handleCloseSideBySideSettings(event);
  };

  const conceptId = selectedConceptId();
  const conceptName = conceptById(conceptId).name;

  return (
    <div>
      <DropdownButton buttonName="Export Heatmap">
        <ul className="selector-list">
          <li>
            <a
              className="-outline"
              href={ reportPath }
              onClick={ (event) => { openReport(event, pptxHeatmapParams()); } }
            >
              All concepts
            </a>
          </li>
          <li>
            <a
              className="-outline"
              href={ reportPath }
              onClick={ (event) => { openReport(event, pptxHeatmapParams(null, conceptId)); } }
            >
              All concepts - Current Settings
            </a>
          </li>
          <li>
            <a
              className="-outline"
              href={ reportPath }
              onClick={ handleOpenSideBySideSettings }
            >
              All concepts side-by-side - Current Settings...
            </a>
          </li>
          {
            !!conceptId &&
            <li>
              <a
                className="-outline"
                href={ reportPath }
                onClick={ (event) => { openReport(event, pptxHeatmapParams(conceptId)); } }
              >
                Selected concept ({ conceptName })
              </a>
            </li>
          }
        </ul>
      </DropdownButton>

      <DropdownButton buttonName="Export XLSX Markup Data">
        <li>
          <a
            className="-outline"
            href={ reportPath }
            onClick={ (event) => { openReport(event, xlsxMarkupParams()); } }
          >
            All concepts
          </a>
        </li>
        <li>
          <a
            className="-outline"
            href={ reportPath }
            onClick={ (event) => { openReport(event, xlsxMarkupParams(null, conceptId)); } }
          >
            All concepts - Current Settings
          </a>
        </li>
        {
          !!conceptId &&
          <li>
            <a
              className="-outline"
              href={ reportPath }
              onClick={ (event) => { openReport(event, xlsxMarkupParams(conceptId)); } }
            >
              Selected concept ({ conceptName })
            </a>
          </li>
        }
      </DropdownButton>

      <DropdownButton buttonName="Export PPT Markup Data">
        <li>
          <a
            className="-outline"
            href={ reportPath }
            onClick={ (event) => { openReport(event, pptxMarkupParams()); } }
          >
            All concepts
          </a>
        </li>
        <li>
          <a
            className="-outline"
            href={ reportPath }
            onClick={ (event) => { openReport(event, pptxMarkupParams(null, conceptId)); } }
          >
            All concepts - Current Settings
          </a>
        </li>
        {
          !!conceptId &&
          <li>
            <a
              className="-outline"
              href={ reportPath }
              onClick={ (event) => { openReport(event, pptxMarkupParams(conceptId)); } }
            >
              Selected concept ({ conceptName })
            </a>
          </li>
        }
      </DropdownButton>

      <SideBySideModal
        modalOpened={ sideBySideConcepts }
        onClose={ handleCloseSideBySideSettings }
        concepts={ sideBySideConcepts }
        onSubmit={ runSideBySideExport }
      />
    </div>
  );
};

export default Reports;
